import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContactTopic, InfoPerso } from '../models/InfoPerso.model';
import { environment } from "environments/environment";
import { COUNTRIES } from '../../../config/countries'
import { JobItem } from '../models/JobItem.model';
import { lastValueFrom } from 'rxjs';
import { GS1NotificationLevel, GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
 let __URL_API__  = `${environment.URL_API}`; 
 const settingFonction  = environment.jobIdValues; 

@Injectable({providedIn: 'root'})
export class FormulaireDonneePersoService {
    constructor(private _http: HttpClient, private notificationService: GS1NotificationService, private translate: TranslateService, private router: Router) {
    }

    async getInfoPerso(): Promise<InfoPerso> {
        try {
            let infoPerso = await lastValueFrom(this._http.get<InfoPerso>(__URL_API__ + 'api/Contact/GetContact'));
            return infoPerso;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async UpdateInfosPerso(form: InfoPerso): Promise<string> {

        let countryCode = "";
        if (form.pays)
        {
            countryCode = COUNTRIES.find((country:any) => country.alpha2Code.toUpperCase() == form.pays.toUpperCase())?.alpha2Code ?? "";
            form.pays = countryCode;
        }

        try {
            let response = await lastValueFrom(this._http.put(__URL_API__ + 'api/Contact/Update', form));
            this.sendNotif('Formulaire.Notifications.success', 'success');
            return response as string;
        } catch (error) {
            return await this.handleError(error, 'Formulaire.Notifications.error');
        }
    }

    public getSubscriptions() {
        var response = ["Actualités GS1 France", "Informations et actualités Standardisation", "Evnéments et webinaires"];
        return response;
    }

    private sendNotif(message: string, level: GS1NotificationLevel) {
        this.notificationService.addNotification(this.translate.instant(message), level);
    }

    private handleError(error: any, msg?: string): Promise<any> {
        if(error && error.error && error.error.includes('dont have acces to')) {
            this.router.navigate(["/unauthorizedContact/CLI-01"]);
        }
        if (msg) {
            this.sendNotif(msg, 'error');
        }
        return Promise.reject(error.message || error);
    }

    async getTopics(): Promise<ContactTopic[]> {
        try {
            let topics = await lastValueFrom(this._http.get<ContactTopic[]>(__URL_API__ + 'api/Contact/GetTopics'));
            return topics;
        } catch (error) {
            return await this.handleError(error);
        }
    }

}